module.exports = __webpack_public_path__ + "static/media/Logo Mighty Jungle Transparent.1e8e0b83.png";